export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f8ce5e4e61c2d41e3bfed84236e071b3e36499a44&name=fetchTypeahead!'